// This file is auto-generated by @hey-api/openapi-ts

import type { AssetsAssetIdCustomAttributesDefinitionIdPutResponse, AssetsAssetIdIpAddressesGetResponse, AssetsAssetIdMacAddressesGetResponse, AssetsAssetIdProcessesGetResponse, AssetsAssetIdProcessesProcessGetResponse, AssetsAssetIdStatePatchResponse, AssetsCommunicationsDaysByAssetGetResponse, AssetsCommunicationsGapsGetResponse, AssetsCommunicationsGetResponse, AssetsCommunicationsHourlyByAssetGetResponse, AssetsCommunicationsHourlyByIpGetResponse, AssetsCommunicationsHourlyByTupleGetResponse, AssetsConnectionsGetResponse, AssetsFindingsGetResponse, AssetsGetResponse, AssetsIdGetResponse, AssetsIdPatchResponse, AssetsNetworkActivityPostResponse, AssetsProcessesGetResponse, AssetsProcessTreeGetResponse, AssetsQuerySetsGetResponse, AssetsQuerySetsPostResponse, AssetsQuerySetsPutResponse, AssetsServicesGetResponse, AssetsServicesGroupedGetResponse, BuildingsGetResponse, BuildingsIdGetResponse, BuildingsPostResponse, BuildingsPutResponse, CustomAssetAttributesGetResponse, CustomAssetAttributesPostResponse, CustomAssetAttributesPutResponse, EndpointSensorsGetResponse, EndpointSensorsIdGetResponse, EndpointSensorsPutResponse, FindingHistoryGetResponse, FindingsGetResponse, FindingsIdGetResponse, GalvanickAppliancesGetResponse, GalvanickAppliancesIdGetResponse, GalvanickAppliancesPostResponse, GalvanickAppliancesPutResponse, HuntReportsGetResponse, IdsEventsGetResponse, IdsEventsGroupedCategoriesGetResponse, IdsEventsGroupedRulesGetResponse, IdsEventsIdGetResponse, IpEnrichmentGetResponse, IpEnrichmentHistoryGetResponse, NetworkPrefixesGetResponse, NetworkPrefixesIdGetResponse, NetworkPrefixesPostResponse, NetworkPrefixesPutResponse, RollupsAffectedAssetsByDayGetResponse, RollupsAssetsByDayGetResponse, RollupsDashboardGetResponse, RollupsDataTransferByDayGetResponse, SuppressionsGetResponse, SuppressionsUpsertResponse, TicketsCommentGetResponse, TicketsCommentPostResponse, TicketsHistoryPostResponse, UsersEnabledPutResponse, UsersEventsGetResponse, UsersIdCredentialsGetResponse, UsersIdEventsGetResponse, UsersIdGetResponse, UsersIdPatchResponse, UsersOrganizationsIdGetResponse, UsersPostResponse, VlansGetResponse, VlansIdGetResponse, VlansPostResponse, VlansPutResponse, VrfsGetResponse, VrfsIdGetResponse, VrfsPostResponse, VrfsPutResponse } from './types.gen';

const assetSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsGetResponseTransformer = async (data: any): Promise<AssetsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetSchemaResponseTransformer(item));
    }
    return data;
};

export const assetsFindingsGetResponseTransformer = async (data: any): Promise<AssetsFindingsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetSchemaResponseTransformer(item));
    }
    return data;
};

export const assetsIdGetResponseTransformer = async (data: any): Promise<AssetsIdGetResponse> => {
    data = assetSchemaResponseTransformer(data);
    return data;
};

export const assetsIdPatchResponseTransformer = async (data: any): Promise<AssetsIdPatchResponse> => {
    data = assetSchemaResponseTransformer(data);
    return data;
};

export const assetsAssetIdStatePatchResponseTransformer = async (data: any): Promise<AssetsAssetIdStatePatchResponse> => {
    data = assetSchemaResponseTransformer(data);
    return data;
};

const ipAddressSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    if (data.expiry_timestamp) {
        data.expiry_timestamp = new Date(data.expiry_timestamp);
    }
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsAssetIdIpAddressesGetResponseTransformer = async (data: any): Promise<AssetsAssetIdIpAddressesGetResponse> => {
    data = data.map((item: any) => ipAddressSchemaResponseTransformer(item));
    return data;
};

const macAddressSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsAssetIdMacAddressesGetResponseTransformer = async (data: any): Promise<AssetsAssetIdMacAddressesGetResponse> => {
    data = data.map((item: any) => macAddressSchemaResponseTransformer(item));
    return data;
};

const assetCustomAttributeValuesSchemaResponseTransformer = (data: any) => {
    if (data.last_modified_timestamp) {
        data.last_modified_timestamp = new Date(data.last_modified_timestamp);
    }
    return data;
};

export const assetsAssetIdCustomAttributesDefinitionIdPutResponseTransformer = async (data: any): Promise<AssetsAssetIdCustomAttributesDefinitionIdPutResponse> => {
    data = assetCustomAttributeValuesSchemaResponseTransformer(data);
    return data;
};

const assetCommunicationSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    return data;
};

export const assetsCommunicationsGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetCommunicationSchemaResponseTransformer(item));
    }
    return data;
};

const ipEnrichmentSchemaResponseTransformer = (data: any) => {
    if (data.last_confirm_at) {
        data.last_confirm_at = new Date(data.last_confirm_at);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const ipEnrichmentGetResponseTransformer = async (data: any): Promise<IpEnrichmentGetResponse> => {
    data = data.map((item: any) => ipEnrichmentSchemaResponseTransformer(item));
    return data;
};

export const ipEnrichmentHistoryGetResponseTransformer = async (data: any): Promise<IpEnrichmentHistoryGetResponse> => {
    data = data.map((item: any) => ipEnrichmentSchemaResponseTransformer(item));
    return data;
};

const assetCommunicationGapResultSchemaResponseTransformer = (data: any) => {
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsCommunicationsGapsGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsGapsGetResponse> => {
    data = data.map((item: any) => assetCommunicationGapResultSchemaResponseTransformer(item));
    return data;
};

const assetCommunicationHourlyByAssetSchemaResponseTransformer = (data: any) => {
    data.hour_start = new Date(data.hour_start);
    return data;
};

export const assetsCommunicationsHourlyByAssetGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsHourlyByAssetGetResponse> => {
    data = data.map((item: any) => assetCommunicationHourlyByAssetSchemaResponseTransformer(item));
    return data;
};

const assetCommunicationHourlyByIpSchemaResponseTransformer = (data: any) => {
    data.hour_start = new Date(data.hour_start);
    return data;
};

export const assetsCommunicationsHourlyByIpGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsHourlyByIpGetResponse> => {
    data = data.map((item: any) => assetCommunicationHourlyByIpSchemaResponseTransformer(item));
    return data;
};

const assetCommunicationDayByAssetSchemaResponseTransformer = (data: any) => {
    data.day = new Date(data.day);
    return data;
};

export const assetsCommunicationsDaysByAssetGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsDaysByAssetGetResponse> => {
    data = data.map((item: any) => assetCommunicationDayByAssetSchemaResponseTransformer(item));
    return data;
};

const assetActivitySchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    return data;
};

export const assetsNetworkActivityPostResponseTransformer = async (data: any): Promise<AssetsNetworkActivityPostResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetActivitySchemaResponseTransformer(item));
    }
    return data;
};

const assetCommunicationHourlyByTupleSchemaResponseTransformer = (data: any) => {
    if (data.first_seen_timestamp) {
        data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    }
    if (data.last_seen_timestamp) {
        data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    }
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsCommunicationsHourlyByTupleGetResponseTransformer = async (data: any): Promise<AssetsCommunicationsHourlyByTupleGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetCommunicationHourlyByTupleSchemaResponseTransformer(item));
    }
    return data;
};

const assetConnectionSchemaResponseTransformer = (data: any) => {
    data.log_timestamp = new Date(data.log_timestamp);
    data.timestamp = new Date(data.timestamp);
    data.hour_start = new Date(data.hour_start);
    return data;
};

export const assetsConnectionsGetResponseTransformer = async (data: any): Promise<AssetsConnectionsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetConnectionSchemaResponseTransformer(item));
    }
    return data;
};

const processTreeSchemaResponseTransformer = (data: any) => {
    data.log_timestamp = new Date(data.log_timestamp);
    return data;
};

export const assetsProcessTreeGetResponseTransformer = async (data: any): Promise<AssetsProcessTreeGetResponse> => {
    data = data.map((item: any) => processTreeSchemaResponseTransformer(item));
    return data;
};

const assetProcessSchemaResponseTransformer = (data: any) => {
    data.log_timestamp = new Date(data.log_timestamp);
    data.timestamp = new Date(data.timestamp);
    if (data.seen_timestamp) {
        data.seen_timestamp = new Date(data.seen_timestamp);
    }
    return data;
};

export const assetsProcessesGetResponseTransformer = async (data: any): Promise<AssetsProcessesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetProcessSchemaResponseTransformer(item));
    }
    return data;
};

const assetProcessGroupedSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    data.timestamp = new Date(data.timestamp);
    return data;
};

export const assetsAssetIdProcessesGetResponseTransformer = async (data: any): Promise<AssetsAssetIdProcessesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetProcessGroupedSchemaResponseTransformer(item));
    }
    return data;
};

export const assetsAssetIdProcessesProcessGetResponseTransformer = async (data: any): Promise<AssetsAssetIdProcessesProcessGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetProcessSchemaResponseTransformer(item));
    }
    return data;
};

const assetSavedQuerySetSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const assetsQuerySetsGetResponseTransformer = async (data: any): Promise<AssetsQuerySetsGetResponse> => {
    data = data.map((item: any) => assetSavedQuerySetSchemaResponseTransformer(item));
    return data;
};

export const assetsQuerySetsPostResponseTransformer = async (data: any): Promise<AssetsQuerySetsPostResponse> => {
    data = assetSavedQuerySetSchemaResponseTransformer(data);
    return data;
};

export const assetsQuerySetsPutResponseTransformer = async (data: any): Promise<AssetsQuerySetsPutResponse> => {
    data = assetSavedQuerySetSchemaResponseTransformer(data);
    return data;
};

const assetServiceSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    return data;
};

export const assetsServicesGetResponseTransformer = async (data: any): Promise<AssetsServicesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetServiceSchemaResponseTransformer(item));
    }
    return data;
};

const assetServiceGroupedSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    return data;
};

export const assetsServicesGroupedGetResponseTransformer = async (data: any): Promise<AssetsServicesGroupedGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => assetServiceGroupedSchemaResponseTransformer(item));
    }
    return data;
};

const findingSchemaResponseTransformer = (data: any) => {
    if (data.first_event_timestamp) {
        data.first_event_timestamp = new Date(data.first_event_timestamp);
    }
    if (data.last_event_timestamp) {
        data.last_event_timestamp = new Date(data.last_event_timestamp);
    }
    if (data.last_analysis_timestamp) {
        data.last_analysis_timestamp = new Date(data.last_analysis_timestamp);
    }
    return data;
};

export const findingsGetResponseTransformer = async (data: any): Promise<FindingsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => findingSchemaResponseTransformer(item));
    }
    return data;
};

const geminiHistorySchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

const findingHistorySchemaResponseTransformer = (data: any) => {
    if (data.first_event_timestamp) {
        data.first_event_timestamp = new Date(data.first_event_timestamp);
    }
    if (data.last_event_timestamp) {
        data.last_event_timestamp = new Date(data.last_event_timestamp);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

const ticketSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

const ticketHistorySchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

const ticketCommentSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

const fullFindingSchemaResponseTransformer = (data: any) => {
    if (data.finding) {
        data.finding = findingSchemaResponseTransformer(data.finding);
    }
    if (data.gemini_history) {
        data.gemini_history = data.gemini_history.map((item: any) => geminiHistorySchemaResponseTransformer(item));
    }
    if (data.history) {
        data.history = data.history.map((item: any) => findingHistorySchemaResponseTransformer(item));
    }
    if (data.ticket) {
        data.ticket = ticketSchemaResponseTransformer(data.ticket);
    }
    if (data.ticket_history) {
        data.ticket_history = data.ticket_history.map((item: any) => ticketHistorySchemaResponseTransformer(item));
    }
    if (data.comments) {
        data.comments = data.comments.map((item: any) => ticketCommentSchemaResponseTransformer(item));
    }
    return data;
};

export const findingsIdGetResponseTransformer = async (data: any): Promise<FindingsIdGetResponse> => {
    data = fullFindingSchemaResponseTransformer(data);
    return data;
};

const findingHistoryLimitedSchemaResponseTransformer = (data: any) => {
    if (data.first_event_timestamp) {
        data.first_event_timestamp = new Date(data.first_event_timestamp);
    }
    if (data.last_event_timestamp) {
        data.last_event_timestamp = new Date(data.last_event_timestamp);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const findingHistoryGetResponseTransformer = async (data: any): Promise<FindingHistoryGetResponse> => {
    data = data.map((item: any) => findingHistoryLimitedSchemaResponseTransformer(item));
    return data;
};

const bucketFileSchemaResponseTransformer = (data: any) => {
    if (data.last_modified) {
        data.last_modified = new Date(data.last_modified);
    }
    return data;
};

const huntReportListSchemaResponseTransformer = (data: any) => {
    if (data.files) {
        data.files = data.files.map((item: any) => bucketFileSchemaResponseTransformer(item));
    }
    return data;
};

export const huntReportsGetResponseTransformer = async (data: any): Promise<HuntReportsGetResponse> => {
    data = huntReportListSchemaResponseTransformer(data);
    return data;
};

const suricataEventSchemaResponseTransformer = (data: any) => {
    data.load_start_time = new Date(data.load_start_time);
    data.upload_time = new Date(data.upload_time);
    data.timestamp = new Date(data.timestamp);
    data.log_timestamp = new Date(data.log_timestamp);
    return data;
};

export const idsEventsGetResponseTransformer = async (data: any): Promise<IdsEventsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => suricataEventSchemaResponseTransformer(item));
    }
    return data;
};

const suricataCategoryGroupSchemaResponseTransformer = (data: any) => {
    data.first_seen = new Date(data.first_seen);
    data.last_seen = new Date(data.last_seen);
    return data;
};

export const idsEventsGroupedCategoriesGetResponseTransformer = async (data: any): Promise<IdsEventsGroupedCategoriesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => suricataCategoryGroupSchemaResponseTransformer(item));
    }
    return data;
};

const suricataRuleGroupSchemaResponseTransformer = (data: any) => {
    data.first_seen = new Date(data.first_seen);
    data.last_seen = new Date(data.last_seen);
    return data;
};

export const idsEventsGroupedRulesGetResponseTransformer = async (data: any): Promise<IdsEventsGroupedRulesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => suricataRuleGroupSchemaResponseTransformer(item));
    }
    return data;
};

export const idsEventsIdGetResponseTransformer = async (data: any): Promise<IdsEventsIdGetResponse> => {
    data = suricataEventSchemaResponseTransformer(data);
    return data;
};

const assetsByDayRollupElementSchemaResponseTransformer = (data: any) => {
    data.day = new Date(data.day);
    return data;
};

export const rollupsAffectedAssetsByDayGetResponseTransformer = async (data: any): Promise<RollupsAffectedAssetsByDayGetResponse> => {
    data = data.map((item: any) => assetsByDayRollupElementSchemaResponseTransformer(item));
    return data;
};

export const rollupsAssetsByDayGetResponseTransformer = async (data: any): Promise<RollupsAssetsByDayGetResponse> => {
    data = data.map((item: any) => assetsByDayRollupElementSchemaResponseTransformer(item));
    return data;
};

const dashboardRollupSchemaResponseTransformer = (data: any) => {
    if (data.ticket_counts) {
        data.ticket_counts = data.ticket_counts.map((item: any) => {
            if (item.start) {
                item.start = new Date(item.start);
            }
            if (item.end) {
                item.end = new Date(item.end);
            }
            return item;
        });
    }
    return data;
};

export const rollupsDashboardGetResponseTransformer = async (data: any): Promise<RollupsDashboardGetResponse> => {
    data = dashboardRollupSchemaResponseTransformer(data);
    return data;
};

const dataTransferByDayRollupElementSchemaResponseTransformer = (data: any) => {
    data.day = new Date(data.day);
    return data;
};

export const rollupsDataTransferByDayGetResponseTransformer = async (data: any): Promise<RollupsDataTransferByDayGetResponse> => {
    data = data.map((item: any) => dataTransferByDayRollupElementSchemaResponseTransformer(item));
    return data;
};

const vrfSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const vrfsGetResponseTransformer = async (data: any): Promise<VrfsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => vrfSchemaResponseTransformer(item));
    }
    return data;
};

export const vrfsPostResponseTransformer = async (data: any): Promise<VrfsPostResponse> => {
    data = vrfSchemaResponseTransformer(data);
    return data;
};

export const vrfsPutResponseTransformer = async (data: any): Promise<VrfsPutResponse> => {
    data = vrfSchemaResponseTransformer(data);
    return data;
};

export const vrfsIdGetResponseTransformer = async (data: any): Promise<VrfsIdGetResponse> => {
    data = vrfSchemaResponseTransformer(data);
    return data;
};

const vlanSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const vlansGetResponseTransformer = async (data: any): Promise<VlansGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => vlanSchemaResponseTransformer(item));
    }
    return data;
};

export const vlansPostResponseTransformer = async (data: any): Promise<VlansPostResponse> => {
    data = vlanSchemaResponseTransformer(data);
    return data;
};

export const vlansPutResponseTransformer = async (data: any): Promise<VlansPutResponse> => {
    data = vlanSchemaResponseTransformer(data);
    return data;
};

export const vlansIdGetResponseTransformer = async (data: any): Promise<VlansIdGetResponse> => {
    data = vlanSchemaResponseTransformer(data);
    return data;
};

const networkPrefixSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const networkPrefixesGetResponseTransformer = async (data: any): Promise<NetworkPrefixesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => networkPrefixSchemaResponseTransformer(item));
    }
    return data;
};

export const networkPrefixesPostResponseTransformer = async (data: any): Promise<NetworkPrefixesPostResponse> => {
    data = networkPrefixSchemaResponseTransformer(data);
    return data;
};

export const networkPrefixesPutResponseTransformer = async (data: any): Promise<NetworkPrefixesPutResponse> => {
    data = networkPrefixSchemaResponseTransformer(data);
    return data;
};

export const networkPrefixesIdGetResponseTransformer = async (data: any): Promise<NetworkPrefixesIdGetResponse> => {
    data = networkPrefixSchemaResponseTransformer(data);
    return data;
};

const buildingSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const buildingsGetResponseTransformer = async (data: any): Promise<BuildingsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => buildingSchemaResponseTransformer(item));
    }
    return data;
};

export const buildingsPostResponseTransformer = async (data: any): Promise<BuildingsPostResponse> => {
    data = buildingSchemaResponseTransformer(data);
    return data;
};

export const buildingsPutResponseTransformer = async (data: any): Promise<BuildingsPutResponse> => {
    data = buildingSchemaResponseTransformer(data);
    return data;
};

const customAssetAttributeDefinitionSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    return data;
};

export const customAssetAttributesGetResponseTransformer = async (data: any): Promise<CustomAssetAttributesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => customAssetAttributeDefinitionSchemaResponseTransformer(item));
    }
    return data;
};

export const customAssetAttributesPostResponseTransformer = async (data: any): Promise<CustomAssetAttributesPostResponse> => {
    data = customAssetAttributeDefinitionSchemaResponseTransformer(data);
    return data;
};

export const customAssetAttributesPutResponseTransformer = async (data: any): Promise<CustomAssetAttributesPutResponse> => {
    data = customAssetAttributeDefinitionSchemaResponseTransformer(data);
    return data;
};

export const buildingsIdGetResponseTransformer = async (data: any): Promise<BuildingsIdGetResponse> => {
    data = buildingSchemaResponseTransformer(data);
    return data;
};

const networkSensorLogSourceSchemaResponseTransformer = (data: any) => {
    if (data.last_seen_timestamp) {
        data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    }
    data.tracked_since = new Date(data.tracked_since);
    return data;
};

const galvanickApplianceSchemaResponseTransformer = (data: any) => {
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.last_upload_timestamp) {
        data.last_upload_timestamp = new Date(data.last_upload_timestamp);
    }
    if (data.log_sources) {
        data.log_sources = data.log_sources.map((item: any) => networkSensorLogSourceSchemaResponseTransformer(item));
    }
    return data;
};

export const galvanickAppliancesGetResponseTransformer = async (data: any): Promise<GalvanickAppliancesGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => galvanickApplianceSchemaResponseTransformer(item));
    }
    return data;
};

export const galvanickAppliancesPostResponseTransformer = async (data: any): Promise<GalvanickAppliancesPostResponse> => {
    data = galvanickApplianceSchemaResponseTransformer(data);
    return data;
};

export const galvanickAppliancesPutResponseTransformer = async (data: any): Promise<GalvanickAppliancesPutResponse> => {
    data = galvanickApplianceSchemaResponseTransformer(data);
    return data;
};

export const galvanickAppliancesIdGetResponseTransformer = async (data: any): Promise<GalvanickAppliancesIdGetResponse> => {
    data = galvanickApplianceSchemaResponseTransformer(data);
    return data;
};

const endpointSensorLogSourceSchemaResponseTransformer = (data: any) => {
    if (data.last_seen_timestamp) {
        data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    }
    data.tracked_since = new Date(data.tracked_since);
    return data;
};

const endpointSensorUploaderSchemaResponseTransformer = (data: any) => {
    data.first_seen_timestamp = new Date(data.first_seen_timestamp);
    data.last_seen_timestamp = new Date(data.last_seen_timestamp);
    return data;
};

const endpointSensorSchemaResponseTransformer = (data: any) => {
    if (data.last_modified_timestamp) {
        data.last_modified_timestamp = new Date(data.last_modified_timestamp);
    }
    if (data.timestamp) {
        data.timestamp = new Date(data.timestamp);
    }
    if (data.last_upload_timestamp) {
        data.last_upload_timestamp = new Date(data.last_upload_timestamp);
    }
    if (data.log_sources) {
        data.log_sources = data.log_sources.map((item: any) => endpointSensorLogSourceSchemaResponseTransformer(item));
    }
    if (data.uploaded_via) {
        data.uploaded_via = data.uploaded_via.map((item: any) => endpointSensorUploaderSchemaResponseTransformer(item));
    }
    if (data.first_winlogbeat_upload_timestamp) {
        data.first_winlogbeat_upload_timestamp = new Date(data.first_winlogbeat_upload_timestamp);
    }
    return data;
};

export const endpointSensorsGetResponseTransformer = async (data: any): Promise<EndpointSensorsGetResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => endpointSensorSchemaResponseTransformer(item));
    }
    return data;
};

export const endpointSensorsPutResponseTransformer = async (data: any): Promise<EndpointSensorsPutResponse> => {
    data = endpointSensorSchemaResponseTransformer(data);
    return data;
};

export const endpointSensorsIdGetResponseTransformer = async (data: any): Promise<EndpointSensorsIdGetResponse> => {
    data = endpointSensorSchemaResponseTransformer(data);
    return data;
};

export const ticketsCommentGetResponseTransformer = async (data: any): Promise<TicketsCommentGetResponse> => {
    data = data.map((item: any) => ticketCommentSchemaResponseTransformer(item));
    return data;
};

export const ticketsCommentPostResponseTransformer = async (data: any): Promise<TicketsCommentPostResponse> => {
    data = ticketCommentSchemaResponseTransformer(data);
    return data;
};

export const ticketsHistoryPostResponseTransformer = async (data: any): Promise<TicketsHistoryPostResponse> => {
    data = ticketHistorySchemaResponseTransformer(data);
    return data;
};

const userDetailSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    return data;
};

const createdUserSchemaResponseTransformer = (data: any) => {
    data = userDetailSchemaResponseTransformer(data);
    return data;
};

export const usersPostResponseTransformer = async (data: any): Promise<UsersPostResponse> => {
    data = createdUserSchemaResponseTransformer(data);
    return data;
};

const userEventSchemaResponseTransformer = (data: any) => {
    data.at = new Date(data.at);
    return data;
};

export const usersEventsGetResponseTransformer = async (data: any): Promise<UsersEventsGetResponse> => {
    data = data.map((item: any) => userEventSchemaResponseTransformer(item));
    return data;
};

const organizationDetailSchemaResponseTransformer = (data: any) => {
    if (data.users) {
        data.users = data.users.map((item: any) => userDetailSchemaResponseTransformer(item));
    }
    return data;
};

export const usersOrganizationsIdGetResponseTransformer = async (data: any): Promise<UsersOrganizationsIdGetResponse> => {
    data = organizationDetailSchemaResponseTransformer(data);
    return data;
};

export const usersIdGetResponseTransformer = async (data: any): Promise<UsersIdGetResponse> => {
    data = userDetailSchemaResponseTransformer(data);
    return data;
};

export const usersIdPatchResponseTransformer = async (data: any): Promise<UsersIdPatchResponse> => {
    data = userDetailSchemaResponseTransformer(data);
    return data;
};

const userCredentialSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    return data;
};

export const usersIdCredentialsGetResponseTransformer = async (data: any): Promise<UsersIdCredentialsGetResponse> => {
    data = data.map((item: any) => userCredentialSchemaResponseTransformer(item));
    return data;
};

export const usersEnabledPutResponseTransformer = async (data: any): Promise<UsersEnabledPutResponse> => {
    data = userDetailSchemaResponseTransformer(data);
    return data;
};

export const usersIdEventsGetResponseTransformer = async (data: any): Promise<UsersIdEventsGetResponse> => {
    data = data.map((item: any) => userEventSchemaResponseTransformer(item));
    return data;
};

const suppressionRecordSchemaResponseTransformer = (data: any) => {
    if (data.expires_at) {
        data.expires_at = new Date(data.expires_at);
    }
    return data;
};

export const suppressionsGetResponseTransformer = async (data: any): Promise<SuppressionsGetResponse> => {
    if (data.suppressions) {
        data.suppressions = data.suppressions.map((item: any) => suppressionRecordSchemaResponseTransformer(item));
    }
    return data;
};

export const suppressionsUpsertResponseTransformer = async (data: any): Promise<SuppressionsUpsertResponse> => {
    if (data.suppression) {
        data.suppression = suppressionRecordSchemaResponseTransformer(data.suppression);
    }
    return data;
};
